import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import Sidebar from "../components/Layout/Sidebar";

const Layout: React.FC<{ children: any }> = ({ children }) => {
  const { i18n } = useTranslation();
  const appContainer = useRef(null);

  return (
    <>
      <div ref={appContainer} className="toggle-sidebar" id="app-wrapper">
        <Header appContainer={appContainer} />
        <Sidebar />
        <main id="main" className="main">
          {children}
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
